
import * as types from './_actionTypes';
export const fetchStudentsRequest = (params = {}) => ({
  type: types.FETCH_STUDENTS_REQUEST,
  payload: params
});

export const fetchStudentsSuccess = (data) => ({
  type: types.FETCH_STUDENTS_SUCCESS,
  payload: data
});

export const fetchStudentsFailure = (error) => ({
  type: types.FETCH_STUDENTS_FAILURE,
  payload: error
});

// Upload Students Actions
export const uploadStudentsRequest = (data) => ({
  type: types.UPLOAD_STUDENTS_REQUEST,
  payload: data
});

export const uploadStudentsSuccess = (result) => ({
  type: types.UPLOAD_STUDENTS_SUCCESS,
  payload: result
});

export const uploadStudentsFailure = (error) => ({
  type: types.UPLOAD_STUDENTS_FAILURE,
  payload: error
});

// Update Student Actions
export const updateStudentRequest = (studentId, updateData) => ({
  type: types.UPDATE_STUDENT_REQUEST,
  payload: { studentId, updateData }
});

export const updateStudentSuccess = (student) => ({
  type: types.UPDATE_STUDENT_SUCCESS,
  payload: student
});

export const updateStudentFailure = (error) => ({
  type: types.UPDATE_STUDENT_FAILURE,
  payload: error
});